import { routeHead } from "@/lib/routeHead";
import { META_DESCRIPTIONS } from "@/lib/metaDescriptions";
import { createFileRoute } from "@tanstack/react-router";
import ContactPage from "@/pages/ContactPage";

export const Route = createFileRoute("/by/contact")({
  head: () => routeHead('Кантакт з AGAPE — Запішыцеся на размову', META_DESCRIPTIONS.contact.by, '/by/contact'),
  component: ContactPage,
});
